import type { FC } from 'react';
import { memo, useMemo } from 'react';
import ProductPageMediaContainer from './ProductPageMediaContainer';
import UIicons from '@ui-kit';

import { Bell, ProductIcons, ProductPageSocialLinks } from '../components';
import Badges from '@root/src/ui/components/ProductCard/componentsNew/Badges';
import type { Badge } from '@utils/prepareBadges';
import Favorite from '../FavoriteBtn';

const { productCardErrorImg } = UIicons;

interface ProductPageMediaProps {
  images: Array<{ type: 'img'; original?: string; src: string; thumb: string }>;
  videos: Array<{ type: 'video'; src: string; thumb: string }>;
  is_18plus: boolean;
  badges: Badge[];
  title: string;
  isFreeze: boolean;
  isExpressPickupAval: boolean;
  isExpressDeliveryAval: boolean;
  id;
  isFavorite;
  isShowBell;
  // isDisabledPopup
}

const ProductPageMedia: FC<ProductPageMediaProps> = ({
  images,
  videos,
  badges,
  title,
  is_18plus,
  isFreeze,
  isExpressPickupAval,
  isExpressDeliveryAval,
  id,
  isFavorite,
  isShowBell
  // isDisabledPopup
}) => {
  const mediaArr = useMemo(() => {
    const items = is_18plus
      ? (images || []).slice(0, 1)
      : [...(images || []), ...(videos || [])];
    return items.length
      ? items
      : [
          {
            type: 'img' as const,
            original: '',
            thumb: '',
            src: productCardErrorImg.x3
          }
        ];
  }, [images, is_18plus, videos]);
  return (
    <div className='relative md:w-auto md:h-auto sm:w-full sm:h-[17.5rem] sm:mb-5'>
      {badges?.length > 0 && (
        <Badges
          isBehaveAsLink
          badges={badges}
          className='left-[73px] top-2 z-[12]'
        />
      )}
      <div className='absolute z-50 flex flex-col top-2 right-2.5 gap-y-3'>
        <Favorite id={+id} isFavorite={isFavorite} />
        <ProductPageSocialLinks />
        {isShowBell && (
          <Bell
            id={id}
            // isDisabledPopup={isDisabledPopup}
          />
        )}
      </div>
      <ProductPageMediaContainer
        mediaArr={mediaArr}
        title={title}
        is_18plus={is_18plus}
      />
      <ProductIcons
        isFreeze={isFreeze}
        isExpressPickupAval={isExpressPickupAval}
        isExpressDeliveryAval={isExpressDeliveryAval}
      />
    </div>
  );
};

export default memo(ProductPageMedia);
